import { render, staticRenderFns } from "./workorder.vue?vue&type=template&id=bd772116&scoped=true&"
import script from "./workorder.vue?vue&type=script&lang=js&"
export * from "./workorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd772116",
  null
  
)

export default component.exports